import api from "../../utils/axios-util";
import {autodialnumberpopstate } from "../Calls/CallAction"

export const Subdispo = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/subdisposition?dispo_id=${payload}`)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
};
export const CallActivity = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            let state = getState()
            await api
                .post(`/asterdialer/call/activity`,payload)
                .then((response) => {
                   if (response.status == 201){
                    if(state.call.autodialstatus == true && payload.callType == 'AUTO'){
                        dispatch(autodialnumberpopstate())
                    }
                   }
                   
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

};


